import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6dcbcb6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "tabContainer",
  class: "tab-container"
}
const _hoisted_2 = {
  ref: "tabBar",
  class: "tab-bar"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  style: {"pointer-events":"none","background-color":"transparent"},
  class: "tab-text noselect"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labels, (label) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: label,
          class: "tab active",
          onClick: () => _ctx.changeTab(label)
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(label), 1)
        ], 8, _hoisted_3)), [
          [_vShow, !_ctx.hiddenIndexes.includes(_ctx.labels.indexOf(label))]
        ])
      }), 128)),
      _hoisted_5
    ], 512)
  ], 512))
}